module.exports = __webpack_public_path__ + "f51215adc0b68949b6deb1645d87de5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-fist-pump.png
// module id = 2079
// module chunks = 4